export default __webpack_public_path__ + "static/media/logo-website-placeholder.868ba6af.svg";